var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex load-container load1",attrs:{"data-text":_vm.$t('general.loading')}},[_c('div',{staticClass:"loader"})])
}
var staticRenderFns = []

export { render, staticRenderFns }